export default __webpack_public_path__ + "static/media/email-verifier-sheild.40c8e392.svg";